import { createReducer, on, Action } from '@ngrx/store';
import {
  GetStatesFailed,
  GetStatesSuccess,
  ClearStates,
} from './states.actions';
import { StatesState } from './states.model';

export const initialState: StatesState = {
  states: [],
  isResolved: false,
};
export function StatesReducer(state: StatesState | undefined, action: Action) {
  return reducer(state, action);
}

export const reducer = createReducer(
  initialState,
  on(
    GetStatesSuccess,
    (state, { statesResponse }) =>
      ({
        ...state,
        states:
          statesResponse && statesResponse.countries
            ? statesResponse.countries[0].subdivisions
            : [],
        error: null,
        isResolved: true,
      } as any)
  ),
  on(
    GetStatesFailed,
    (state, { payload }) =>
      ({
        ...state,
        states: payload?.states,
        error: payload?.error,
        isResolved: true,
      } as any)
  ),
  on(ClearStates, (state) => initialState)
);
